import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
const galleryItems = [{
  label: 'Bandejas deco',
  desc: 'Para joyas, velas, perfumes o decoración.',
  img: 'https://cdn.magicpatterns.com/uploads/ghej92GTunApWagGZFgwER/BANDEJAS_DECO.jpg'
}, {
  label: 'Velas artesanales',
  desc: 'Recipientes de cemento y yeso con aroma y estilo.',
  img: 'https://cdn.magicpatterns.com/uploads/1oVnsm4fp6iqgAmsgkRSiF/velas_artesanales.jpg'
}, {
  label: 'Porta joyas',
  desc: 'Piezas delicadas para regalar o vender.',
  img: 'https://cdn.magicpatterns.com/uploads/mRqYzBZYPScE5ozZRuUhEq/PORTA_JOYAS.jpg'
}, {
  label: 'Macetas y portavelas',
  desc: 'Ideales para deco hogar y sets personalizados.',
  img: 'https://cdn.magicpatterns.com/uploads/aRQmZqMk3UnoJ8BdJbTMza/MACETAS.jpg'
}, {
  label: 'Souvenirs para eventos',
  desc: 'Opciones para bautismos, comuniones, bodas y cumpleaños.',
  img: 'https://cdn.magicpatterns.com/uploads/kzibPBzgdGAy6Dp9Js8FE5/SOUVENIRS.jpg'
}, {
  label: 'Piezas con espejos',
  desc: 'Bandejas y centros decorativos con terminación premium.',
  img: 'https://cdn.magicpatterns.com/uploads/befTgf4bM6RvGKtfMRecKK/PIEZAS_CON_ESPEJOS.jpg'
}];
export function Gallery() {
  const scrollToPurchase = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-10 sm:py-12 px-4 sm:px-6 lg:px-8 bg-deco-card" data-id="element-55">
      <div className="max-w-7xl mx-auto" data-id="element-56">
        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-10" data-id="element-57">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-4 font-bold" data-id="element-58">
            Mirá todo lo que podés crear con cemento y yeso
          </h2>
          <p className="text-base sm:text-lg text-deco-taupe font-medium" data-id="element-59">
            Piezas modernas, artesanales y con alto valor visual para decorar,
            regalar o vender.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6 lg:gap-8 mb-8" data-id="element-60">
          {galleryItems.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="group relative rounded-[1.5rem] sm:rounded-[2rem] overflow-hidden aspect-[4/5] bg-deco-bg shadow-sm border border-deco-warm" data-id="element-61">
              <img src={item.img} alt={item.label} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-62" />
              <div className="absolute inset-0 bg-gradient-to-t from-deco-text/90 via-deco-text/30 to-transparent opacity-90" data-id="element-63" />
              <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-8" data-id="element-64">
                <h3 className="text-white font-serif text-lg sm:text-2xl font-bold mb-1 sm:mb-2" data-id="element-65">
                  {item.label}
                </h3>
                <p className="text-white/80 text-xs sm:text-base font-medium hidden sm:block" data-id="element-66">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-67">
          <Button onClick={scrollToPurchase} variant="secondary" className="px-10 py-4 text-base" data-id="element-68">
            QUIERO APRENDER A CREARLAS
          </Button>
        </div>
      </div>
    </section>;
}